import { makeStyles } from '@rbx/ui';

const useNullStateStyles = makeStyles()((theme) => ({
  container: {
    flex: 1,
    flexGrow: 1,
    overflow: 'visible',
  },

  header: {
    marginTop: theme.spacing(11),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('Medium')]: {
      marginTop: theme.spacing(1.5),
      marginBottom: 14,
    },
  },

  headerIcon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginTop: -10,
  },

  intro: {
    maxWidth: 700,
    fontSize: 18,
    [theme.breakpoints.down('Medium')]: {
      fontSize: 16,
    },
  },

  metaLicense: {
    color: theme.palette.states.disabled,
    marginTop: theme.spacing(1),
  },

  openInStudioLink: {
    cursor: 'pointer',
  },

  examplesWrapper: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(1),
  },

  examplesIntro: {
    [theme.breakpoints.down('Medium')]: {
      fontSize: 16,
    },
  },
}));

export default useNullStateStyles;
